<mat-progress-bar *ngIf="showLoader" style="margin-top: 2px;" class="col-md-12" mode="indeterminate"></mat-progress-bar>
<div class="row">
  <div class="col-md-12">
    <form [formGroup]="formdataCreate">
      <br />

      <div class="row">
        <div class="col-md-11 gx-0">
          <div class="row inputRow">
            <div class="col-md-12">
              <br />
              <div class="row mb-3">
                <div class="col-md-4">
                  <mat-form-field appearance="outline" id="formDropdown">
                    <mat-label>Document Type</mat-label>
                    <mat-select formControlName="document_type" name="document_type" placeholder="Document Type"
                      (selectionChange)="selectdocumenttype($event.value)" #accountFilter required>
                      <!-- <mat-select-filter *ngIf="accountFilter.focused" [placeholder]="'Filter'"
                                                [displayMember]="'accountName'" [array]="accountList"
                                                (filteredReturn)="accountList1 = $event"></mat-select-filter> -->
                      <mat-option *ngFor="let i of documenttypedropdown" [value]="i.lookup_code">{{i.lookup_code}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" id="formDropdown">
                    <mat-label>Visibility Type</mat-label>
                    <mat-select formControlName="visibility_type" name="account" placeholder="Visibility Type"
                      [(ngModel)]="visibityvaluefromdocumenttype" #accountFilter required disabled>
                      <!-- <mat-select-filter *ngIf="accountFilter.focused" [placeholder]="'Filter'"
                                                [displayMember]="'accountName'" [array]="accountList"
                                                (filteredReturn)="accountList1 = $event"></mat-select-filter> -->
                      <mat-option *ngFor="let i of visibilityList" [value]="i.visibility">{{i.visibility}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4">
                  <mat-form-field appearance="outline" id="onlyForAdmin">
                    <mat-label>Document Name</mat-label>
                    <input matInput id="commonText" name="document_name" placeholder="Document Name"
                      formControlName="document_name" autocomplete="off" required />
                      <mat-error
                        *ngIf="formdataCreate.controls.document_name.hasError('document_name') || !formdataCreate.controls.document_name.hasError('required')">
                        Please Enter a Valid Document Name(A-Z or a-z or 0-9)
                      </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" id="onlyForAdmin">
                    <mat-label>Version</mat-label>
                    <input matInput id="commonText" name="version" placeholder="Version" formControlName="version"
                      autocomplete="off" required />
                      <mat-error
                        *ngIf="formdataCreate.controls.version.hasError('version') || !formdataCreate.controls.version.hasError('required')">
                        Please Enter a Valid  Version(A-Z or a-z or 0-9 and .)
                      </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col-md-4">
                  <mat-form-field appearance="outline" id="onlyForAdmin">
                    <mat-label>Description</mat-label>
                    <input matInput id="commonText" name="description" placeholder="Description"
                      formControlName="description" autocomplete="off" required />
                      <mat-error
                        *ngIf="formdataCreate.controls.description.hasError('description') || !formdataCreate.controls.description.hasError('required')">
                        Please Enter a Valid  Description(A-Z or a-z or 0-9)
                      </mat-error>
                  </mat-form-field>
                </div>
              </div>
              <div class="row mb-3" *ngIf="tenantenableflag">
                <div class="col-md-4">
                  <p class="subtextclass">Is Tenant Specific</p>
                  <mat-slide-toggle formControlName="tenantspecificFlag" (change)="tenattanenable($event)">
                  </mat-slide-toggle>
                </div>
                <div class="col-md-4">
                  <mat-form-field *ngIf="tenantfieldflag" appearance="outline" id="formDropdown">
                    <mat-label>Tenant Name</mat-label>
                    <mat-select formControlName="tenantName" name="tenantName" placeholder="Tenant Name" #accountFilter>
                      <!-- <mat-select-filter *ngIf="accountFilter.focused" [placeholder]="'Filter'"
                                                [displayMember]="'accountName'" [array]="accountList"
                                                (filteredReturn)="accountList1 = $event"></mat-select-filter> -->
                      <mat-option *ngFor="let i of tenantList" [value]="i.name">{{i.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4">
                  <input type="file" formControlName="attachmentFileName"
                    class="col-md-6 massEventTemplateType form-control" id="attachmentFileName"
                    name="attachmentFileName" placeholder="Select file!"
                    accept=".txt, .doc, .docx, .pdf, .xls, .xlsx, .xlsb, .zip, .7z, .jpg, .jpeg, .odt, .ods, .csv"
                    (change)="onFileChange($event)" />
                  <span style="
                            color: grey;
                            font-size: 12px;
                            font-family: Segoe UI;
                          ">(Allowed File Type:pdf) (Max size is 2
                    MB)</span>
                  <mat-error *ngIf="f.attachmentFileName.errors">
                    <p *ngIf="f.attachmentFileName.errors?.format">
                      File format not supported.
                    </p>
                    <p *ngIf="f.attachmentFileName.errors?.size">
                      File size exceeded the limit. Maximum allowable size
                      is 2 MB.
                    </p>
                    <p *ngIf="f.attachmentFileName.errors?.specialCharacters">
                      File name sholud not contain any special characters.
                    </p>
                  </mat-error>
                </div>
              </div>

              <div class="row inputRow" style="height: 40px">
                <div class="col-md-4"></div>
                <div class="col-md-6">
                  <div class="col-md-6">
                    <button class="forsubmit schBtn button-right1" (click)="uploadnewdoc(formdataCreate.value)"
                      mat-button>
                      Create
                    </button>
                  </div>
                  <div class="col-md-6">
                    <button class="cancelButton r-20px" (click)="onBack($event)" mat-button>
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
